<template>
  <div v-if="getPermission.settings.view || getPermission.stc.view">  

    <md-card class="searchPanel"> 
      <md-card-content>
        <div class="md-layout md-gutter">

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.startDate">
                <label>Doc Date From</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.endDate">
                <label>Doc Date To</label>
              </datepicker>
            </div>
          </div>
          
          <div  v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <md-field>
                <label size="lg" class = "textlabel" for="docType" >Status</label>
                  <md-select v-model="searchRequest.billingStatus">
                  <md-option value="UNC">UNC Cost Not Confirm</md-option>
                  <md-option value="BLC">BLC Cost Confirm</md-option>
                  <md-option value="LOK">LOK Cost Locked</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!-- <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <md-field>
                <label>Document#</label>
                <md-input v-model="searchRequest.billingNum"/>
              </md-field>
            </div>
          </div> -->

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <md-field>
                <label>RefDoc#</label>
                <md-input v-model="searchRequest.refDoc"/>
              </md-field>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/apar/listStage']">
              <callingApiCenter path=" /api/w/apar/listStage" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">search</span>Search</md-button>
                <md-button class="md-raised custButton md-primary" v-if="searchRequest.payrollConfirm == 'UNC'" @click="doLock" ><span class="icons-center material-icons">attach_money</span>Confirm</md-button>
                <md-button class="md-raised custButton md-accent" v-if="searchRequest.payrollConfirm == 'BLC'" @click="doUnLock" ><span class="icons-center material-icons">money_off</span>UnConfirm</md-button>
                <md-button class="md-raised custButton" @click="doClear">Clear</md-button>
                <input class = "custSearchBar" type="text"
                        placeholder="Searching Term"
                        v-model="filter"
                        />
                <label > 
                  <span class="lable-center"> Selected:</span> 
                  <span class="lable-center"> {{getselectedCount}}</span>
                </label>

              <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>


    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                          <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                          <md-tooltip md-direction="top">All</md-tooltip>
                        </th>
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('docType')">DocType</th> -->
                      <th class="header-cell center w2" v-on:click="sortFunction('billingStatus')">Status</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('billingNumRateType')">Doc RateType</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Doc Date</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">moveInDate</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('inGateDate')">inGateDate</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">DO#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('customerPO')">CustPO#</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load#</th> -->
                      
                      <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Ctnr#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">chassisNo</th>

                      <th class="header-cell center w2" v-on:click="sortFunction('pf')">PF</th>
                      <th class="header-cell center w7" v-on:click="sortFunction('partner')">Partner</th>

                      <!-- <th class="header-cell center w3" v-on:click="sortFunction('rateType')">Rate Type</th> -->
                      
                      <th class="header-cell center w3" v-on:click="sortFunction('unit')">Price Unit</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('amt')">Amt</th>
                      <th class="header-cell center w1" v-on:click="sortFunction('qty')">Qty</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('tol')">Tol</th>
                      
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('ratedate')">Rate Date</th> -->
                      <th class="header-cell center w10" v-on:click="sortFunction('remark')">Remark</th>
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('orderType')">DO Type</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('agreement')">Price Agreement</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('adesc')">Desc</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">Created</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">Created Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">Update</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">Update Date</th> -->
                      
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">chzStartDate#</th> -->
                      
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">ctnrType</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('moveInBy')">moveInBy</th> -->
                      
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('ownChassis')">ownChassis</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('source')">source</th> -->

                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('stageType')">stageType</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('carrier')">carrier</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('pickupDate')">pickupDate</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('driverId')">driverId</th> -->

                      

                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('truckId')">truckId</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('driverGroup')">driverGroup</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('stageBookingNo')">stageBookingNo</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('pickupLocationCode')">pickupLocationCode</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('pickUpLocationName')">pickUpLocationName</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliverLocationCode')">deliverLocationCode</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliverLocationName')">deliverLocationName</th> -->
                    
                    </tr>
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <md-checkbox v-if="searchRequest.payrollConfirm != 'LOK'" v-model="item.selected">
                          <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                        </md-checkbox>
                      </td>
                      <!-- <td class="body-cell excelBox w5">{{item.docType}}</td> -->
                      <td class="body-cell excelBox w2">{{item.billingStatus}}</td> 
                      <td class="body-cell excelBox w6">{{item.billingNumRateType}}</td>  
                      <td class="body-cell excelBox w5">{{item.rdesc}}</td>
                      <td class="body-cell excelBox w5">{{item.billingDate | date}}</td>
                      <td class="body-cell excelBox w6">{{item.refDoc}}</td> 
                      <!-- <td class="body-cell excelBox w5">{{item.moveInDate | date}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.inGateDate}}</td> -->

                      <!-- <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>  
                      <td class="body-cell excelBox w5">{{item.customerPO}}</td>   -->
                      <!-- <td class="body-cell excelBox w5">{{item.seqNo}}</td>   -->
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                      <td class="body-cell excelBox w5">{{item.chassisNo}}</td>

                      <td class="body-cell excelBox w2">{{item.pf}}</td>
                      <td class="body-cell excelBox w7">{{item.partner}}</td>

                      <!-- <td class="body-cell excelBox w3">{{item.rateType}}</td> -->
                      
                      <td class="body-cell excelBox w3">{{item.unit}}</td>
                      <td class="body-cell excelBox w2">{{item.amt}}</td>
                      <td class="body-cell excelBox w1">{{item.qty}}</td>
                      <td class="body-cell excelBox w2">{{item.tol}}</td>
                      <!-- <td class="body-cell excelBox w5">{{item.ratedate | date}}</td> -->
                      
                      <td class="body-cell excelBox w10">{{item.remark}}</td>
                      <!-- <td class="body-cell excelBox w5">{{item.orderType}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.agreement}}</td>
                      <td class="body-cell excelBox w5">{{item.adesc}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td> -->

                      <!-- <td class="body-cell excelBox w5">{{item.chzStartDate}}</td> -->
                      
                      <!-- <td class="body-cell excelBox w5">{{item.ctnrType}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.moveInBy}}</td> -->
                      
                      <!-- <td class="body-cell excelBox w5">{{item.ownChassis}}</td>
                      <td class="body-cell excelBox w5">{{item.source}}</td> -->

                      <!-- <td class="body-cell excelBox w5">{{item.stageType}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.carrier}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.pickupDate}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.driverId}}</td> -->

                      

                      <!-- <td class="body-cell excelBox w5">{{item.truckId}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.driverGroup}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.stageBookingNo}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.pickupLocationCode}}</td>
                      <td class="body-cell excelBox w5">{{item.pickUpLocationName}}</td>
                      <td class="body-cell excelBox w5">{{item.deliverLocationCode}}</td>
                      <td class="body-cell excelBox w5">{{item.deliverLocationName}}</td> -->
                      
                      
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
.icons-center {
      vertical-align: middle;
      margin-right: 10px;
      color: rgb(190, 243, 141);
  }
  .inputBox {
      border: 1px solid #cacbcc;
      border-radius: 5px;
      color: #29303b;
      font-size: 18px;
      height: auto;
      line-height: 1.5em;
      padding: 5px 5px 5px 5px;
      margin-top: 5px;
  }
  .selected {
      background: rgb(190, 243, 141);
  }
  .center {
      text-align: center;
  }
  .custButton {
      margin: 10px;
      width: 120px;
      height: 40px;
      line-height:40px;
      font-size: 0.8rem;
  }
  .custSearchBar{
      margin: 10px;
      width: 200px;
      height: 40px;
      line-height:40px;
      font-size: 0.9rem;
      color: blue;
  }
  .custButtonRight {
      margin: 10px;
      width: 100px;
      height: 40px;
      float : right;
      color: green;
  }
  .lable-center {
      margin-left: 10px;
      color: #010855;
      vertical-align: middle;
      margin-right: 10px;
  }
</style>


<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import { newAPIPost } from "../api/index.js";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


  const getInitSearch = () => ({
    salesOffice: "LGB",
    docType: "STAGE",
    billingNum: null,
    deliveryOrder: null,
    customerPO: null,
    seqNo: null,
    refDoc: null,
    agreement: null,
    billingStatus: "UNC",
    selected: false,
    payrollConfirm: "UNC",
    billingDate: {
      startDate: moment().subtract(1,'months').startOf('d').toDate(),
      endDate: moment().add(1,'days').endOf('d').toDate(),
    },
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      active: true,
      items: [],
      sortStatus: true,
      filter:"",
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
    },

    watch: {
      getstageCostMass(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getstageCostMass',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.billingNumRateType).includes(term) ||
                  // this.includeNull(row.deliveryOrder).includes(term) ||
                  // this.includeNull(row.customerPO).includes(term) ||
                  // this.includeNull(row.seqNo).includes(term) ||
                  this.includeNull(row.refDoc).includes(term) ||
                  // this.includeNull(row.rateType).includes(term) ||
                  this.includeNull(row.pf).includes(term) ||
                  this.includeNull(row.partner).includes(term) ||
                  // this.includeNull(row.orderType).includes(term) ||
                  // this.includeNull(row.agreement).includes(term) ||
                  this.includeNull(row.containerNo).includes(term) ||
                  this.includeNull(row.chassisNo).includes(term);
                  // this.includeNull(row.updatedAt).includes(term);
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
      getselectedCount() {
        return this.getSelectedItems.length ; 
      },
    },

    async mounted() {
      const cachedSearchRequest = this.$store.state.stageCostMass.searchRequest;
      this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
      this.searchRequest.salesOffice = 'LGB' ; 
      this.searchRequest.billingDate.startDate = moment().subtract(1,'months').startOf('d').toDate();
      this.searchRequest.billingDate.endDate = moment().add(0,'months').endOf('d').toDate();
      this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getstageCostMass);
      
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },
      mouseLeave: function() {
        this.active = !this.active;
      },

      sortFunction(sortFiled){
        const sorted = _(this.items).sortBy(sortFiled);
        console.log(this.sortStatus)
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus)
        {
            this.items = sorted;
        }
        else
        {
            this.items = sorted.reverse();
        }
      },

      
      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
     },
      
      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource)) ;
        items.forEach((it) => {
          it.selected ;
        });
        this.items = items;         
      },

      doLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.refDoc);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm",
        newAPIPost("/api/w/apar/confirm",
        {
          mode: 'stageConfirm',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              refDoc: it.refDoc
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doUnLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.refDoc);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm", 
        newAPIPost("/api/w/apar/confirm", 
        {
          mode: 'stageUnConfirm',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              refDoc: it.refDoc
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = true;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doSearch() {
        this.active = true;
        if (this.searchRequest.billingDate.startDate == null)
        {
          window.confirm('Document Date From is required!')
        }
        if (this.searchRequest.billingDate.endDate == null)
        {
          window.confirm('Document Date To is required!')
        }


        this.$store.dispatch('stageCostMass', this.searchRequest);
        if (this.searchRequest.billingStatus == "UNC" ){
          this.searchRequest.payrollConfirm = "UNC";
        };

        if (this.searchRequest.billingStatus == "BLC" ){
          this.searchRequest.payrollConfirm = "BLC";
        };

        if (this.searchRequest.billingStatus == "LOK" ){
          this.searchRequest.payrollConfirm = "LOK";
        };
        this.searchRequest.salesOffice = 'LGB';
       },


      doClear(){
        this.filter = "";
        this.searchRequest = getInitSearch();
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },

      includeNull(field){
            return field==null ? '' : field;
      },
    },
  }
</script>